// FaqWithGuide.js
import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import { Box, Typography, Button } from "@mui/material";

const FaqWithGuide = () => {
  const [guideContent, setGuideContent] = useState("");
  const [guideExpanded, setGuideExpanded] = useState(false);

  // Fetch the Markdown file from the public folder when component mounts
  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/gettingStartedForEndUser.md`)
      .then((res) => res.text())
      .then((text) => setGuideContent(text))
      .catch((err) => console.error("Error fetching markdown:", err));
  }, []);

  return (
    <Box sx={{ padding: "20px" }}>
      <Typography variant="h4" gutterBottom fontWeight="bold">
        Frequently Asked Questions
      </Typography> 
      

      <Box sx={{ marginBottom: "20px" }}>
        <Typography variant="h6" fontWeight="bold">
          How do I change my plan?
        </Typography>
        <Typography variant="body1">
          You can change your plan from your business subscription and billing settings.
        </Typography>
      </Box>

      <Box sx={{ marginBottom: "20px" }}>
        <Typography variant="h6" fontWeight="bold">
          What happens if I want to cancel?
        </Typography>
        <Typography variant="body1">
          You can cancel at any time, and you will not be billed for subsequent months.
        </Typography>
      </Box>

      <Box sx={{ marginBottom: "20px" }}>
        <Typography variant="h6" fontWeight="bold">
          Can I upgrade or downgrade my subscription?
        </Typography>
        <Typography variant="body1">
          Yes, you can upgrade or downgrade your subscription at any time in your account settings.
        </Typography>
      </Box>

      <Box sx={{ marginBottom: "20px" }}>
        <Typography variant="h6" fontWeight="bold">
          Is there a free trial available?
        </Typography>
        <Typography variant="body1">
          Yes, we offer a free plan.
        </Typography>
      </Box>

      <Box sx={{ marginBottom: "20px" }}>
        <Typography variant="h6" fontWeight="bold">
          How can I contact you for any enquiries?
        </Typography>
        <Typography variant="body1">
          For any enquiries or additional support, please use our "Contact Us" form on our website or email us directly at support@plany365.com.
        </Typography>
      </Box>


    </Box>
  );
};

export default FaqWithGuide;
